'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PagingModel2 = require('./PagingModel');

var _PagingModel3 = _interopRequireDefault(_PagingModel2);

var _Payment = require('./Payment');

var _Payment2 = _interopRequireDefault(_Payment);

var _Customer = require('./Customer');

var _Customer2 = _interopRequireDefault(_Customer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var moment = require('moment');
moment().format();

var PaymentsModel = function (_PagingModel) {
    _inherits(PaymentsModel, _PagingModel);

    /**
     * Liste von Zahlweisen
     * @type {array} of Payments
     */


    /**
     * Zahlweise zur Neuanlage
     * @type {Payment}
     */

    /**
     * Id des Kunden, an dem die Zahlweise angelegt werden soll
     * @type {string}
     */
    function PaymentsModel(observers, id, request) {
        _classCallCheck(this, PaymentsModel);

        var _this = _possibleConstructorReturn(this, (PaymentsModel.__proto__ || Object.getPrototypeOf(PaymentsModel)).call(this, observers, id, request));

        _this.Payments = [];

        _this.PaymentOption = new _Payment2.default();
        _this.CustomerId = "";
        _this.CustomerPaymentOption = new _Customer2.default();
        return _this;
    }
    /**
     * Kunden, an dem die Zahlweise angelegt werden soll
     * @type {Customer}
     */


    _createClass(PaymentsModel, [{
        key: 'GetPaymentsByCustomerId',
        value: function GetPaymentsByCustomerId(customerId, senddata, start, limit, orderColumn, orderDirection, paymentMethodValue, deadLine) {

            var reqString = "/Customers/" + customerId + "/PaymentOptions" + this.setSendData(senddata, start, limit, orderColumn, orderDirection, null, null, null, null, null, null, paymentMethodValue, deadLine);
            var me = this;

            this.request.setRequest(reqString);
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    me.setResult(result);
                    if (result.Data) {
                        if (result.Data.Data) {
                            me.Payments = result.Data.Data;
                        }
                    }
                }

                var id = me.Id ? me.Id : "Payment";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'SetStandartPaymentsOption',
        value: function SetStandartPaymentsOption() {
            var me = this;
            var sendData = {
                PaymentOption: this.PaymentOption,
                CustomerId: this.CustomerId,
                CustomerPaymentOption: this.CustomerPaymentOption
            };
            this.request.setRequest("/StandardPaymentOptions");
            this.request.setData(JSON.stringify(sendData));
            this.request.setType("PUT");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        me.PaymentOption = result.Data;
                    }
                }
                var id = me.Id ? me.Id : "StandartPaymentsOption";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'CreatePaymentSetDateTo',
        value: function CreatePaymentSetDateTo() {
            var me = this;
            var sendData = {
                PaymentOption: this.PaymentOption,
                CustomerId: this.CustomerId,
                CustomerPaymentOption: this.CustomerPaymentOption
            };
            this.request.setRequest("/PaymentOptions/SetDateTo");
            this.request.setData(JSON.stringify(sendData));
            this.request.setType("POST");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        me.PaymentOption = result.Data;
                    }
                }
                var id = me.Id ? me.Id : "CreatePaymentSetDateTo";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'CreatePayment',
        value: function CreatePayment() {
            var me = this;
            var sendData = {
                PaymentOption: this.PaymentOption,
                CustomerId: this.CustomerId,
                CustomerPaymentOption: this.CustomerPaymentOption
            };
            this.request.setRequest("/PaymentOptions");
            this.request.setData(JSON.stringify(sendData));
            this.request.setType("POST");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        me.PaymentOption = result.Data;
                    }
                }
                var id = me.Id ? me.Id : "CreatePayment";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'ChangePayment',
        value: function ChangePayment(id) {
            var me = this;
            var sendData = {
                PaymentOption: this.PaymentOption,
                CustomerId: this.CustomerId,
                CustomerPaymentOption: this.CustomerPaymentOption
            };
            this.request.setRequest("/PaymentOptions/" + id);
            this.request.setData(JSON.stringify(sendData));
            this.request.setType("PUT");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        me.PaymentOption = result.Data;
                    }
                }
                var id = me.Id ? me.Id : "ChangePayment";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }]);

    return PaymentsModel;
}(_PagingModel3.default);

exports.default = PaymentsModel;